import axios from 'axios';
import { baseUrl } from '../../config';

const API = `${baseUrl}/app-settings`;

const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
    'Content-Type': 'application/json',
  },
});

export const getSettings = async () => {
  const res = await axios.get(API, getHeaders());
  return res.data;
};

export const updateSetting = async (key, setting_value) => {
  const res = await axios.patch(`${API}/${key}`, { setting_value }, getHeaders());
  return res.data;
};
